import { call, cancel, put, take } from 'redux-saga/effects';
import { perf } from './performance';
import { channel } from 'redux-saga';
import { sagaMiddleware } from 'store/store';
import { handleDeskAssignedMessage } from '../transactionSagas/transactionsSagas';
import ChannelBuffer from './ChannelBuffer';

class TransactionChannelManager {
    #channels = new Map();

    *#getChannel(transactionId) {
        let { channel: chan } = this.#channels.get(transactionId) || {};
        if (!chan) {
            chan = yield call(channel, new ChannelBuffer(transactionId));
            const task = sagaMiddleware.run(this.#transactionHandler.bind(this), chan, transactionId);
            this.#channels.set(transactionId, { channel: chan, task, id: transactionId });
            this.#log(`Registered new channel for transactionId=${transactionId}`);
            return chan;
        }
        this.#log(`Channel already exist, reusing channelId=${transactionId}`);
        return chan;
    }

    *#transactionHandler(channel, transactionId) {
        try {
            while (true) {
                const { payload } = yield take(channel);
                perf.mark(payload, perf.markNames.startingToHandle);
                yield call(handleDeskAssignedMessage, payload);
                perf.mark(payload, perf.markNames.handled);
                perf.getMeasurements(payload);
            }
        } catch (err) {
            this.#log('Channel error', err);
        } finally {
            channel.close();
            this.#channels.delete(transactionId);
            this.#log(`Channel closed, channelId=${transactionId}`);
        }
    }

    *processTransaction(transactionId, payload) {
        const channel = yield call([this, this.#getChannel], transactionId);
        this.#log(`Putting message to channelId=${transactionId}`);
        yield put(channel, { payload });
    }

    *closeTransactionPipeline(transactionId) {
        const task = this.#channels.get(transactionId)?.task;
        if (task) yield cancel(task);
    }

    *closeAll() {
        const channels = this.#channels.values();
        for (let { task } of channels) {
            if (task) yield cancel(task);
        }
    }

    #log(message, mode = 'log') {
        console[mode](`[TransactionChannelManager] ${message}`);
    }
}

const transactionManager = new TransactionChannelManager();

export default transactionManager;
